import { handleActions } from 'redux-actions';

export default handleActions(
	{
		CHANGE_LANGUAGE: (state, action) => ({
			...state,
			lan: action.payload.lan,
		}),
	},
	{
		lan: 'zh-TW',
		timeZone: 8,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/i18n.js